import { Directive, ElementRef, Input } from "@angular/core";
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from "@angular/forms";

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
    }
}

@Directive({
    selector: '[mustMatch]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MustMatchDirective, multi: true }]
})
export class MustMatchDirective implements Validator {
    @Input('mustMatch') mustMatch: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        const controlName = this.mustMatch[0];
        const matchingControlName = this.mustMatch[1];
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        // return null if controls haven't initialised yet
        if (!control || !matchingControl) {
            return null;
        }

        // return null if another validator has already found an error on the matchingControl
        if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
            return null;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }

        return null;
    }
}

@Directive({
    selector: '[mustEqual]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MustEqualDirective, multi: true }]
})
export class MustEqualDirective implements Validator {
    @Input('mustEqual') matchingValue: string;

    validate(control: AbstractControl): ValidationErrors {
        if (control.value !== this.matchingValue) {
            return { mustEqual: true };
        }
        return null;
    }
}


@Directive({
    selector: '[valid-control]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ValidControlDirective, multi: true }]
})
export class ValidControlDirective implements Validator {
    constructor(
        private host: ElementRef<HTMLFormElement>) {
    }

    validate(control: AbstractControl): ValidationErrors {
        if (!(this.host.nativeElement as any).validity.valid) {
            return { invalidControl: true };
        }
        return null;
    }
}


@Directive({
    selector: '[validAddress]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ValidAddressDirective, multi: true }]
})
export class ValidAddressDirective implements Validator {
    @Input('validAddress') addressObject: any;

    validate(control: AbstractControl): ValidationErrors {
        if (!this.addressObject) {
            return { validAddress: true };
        }
        return null;
    }
}
